$(document).ready(function() {
  AOS.init({
    duration: 1200
  });

  // Agrupar bestseller + featured
  jQuery('.bestseller-collection,.featured-product').wrapAll('<div class="best-featured"><div class="container"><div class="row"></div></div></div>'); 

  /*--------------- Scroll to top (click) -------------------*/
  jQuery("#GotoTop").on('click', function () {
    jQuery("html, body").animate({ scrollTop: 0 }, 1000);
    return false;
  });
  /*-------------------- END ------------------*/

  // Mobile nav toggle
  jQuery('.nav-toggle').on('click', function(event) {
    jQuery(this).toggleClass('active');
    event.stopPropagation();
    jQuery('#tt-megamenu .tt-mega_menu').slideToggle(2000);
    jQuery('body').toggleClass("open-header");
  });

  jQuery("#tt-megamenu .tt-mega_menu").on("click", function(event) {
    event.stopPropagation();
    jQuery(this).removeClass('active');
  });	

  jQuery("#tt-megamenu1 li.tt_menu_item.tt_mm_hassub").hover(
    function () {
      jQuery('body').addClass("menu-open");
    },
    function () {
      jQuery('body').removeClass("menu-open");
    }
  );

  // Dark / light mode
  jQuery(".dark-light-mode .dark-mode").on("click", function() {    
    jQuery('body').addClass('darkmode');
  });
  jQuery(".dark-light-mode .light-mode").on("click", function() {    
    jQuery('body').removeClass('darkmode');
  });

  // Mini cart note
  jQuery(".cart-footer-actions .cart-note").on("click", function() {    
    jQuery('.mini-cart-footer .note-detail').addClass('open');
  });
  jQuery(".fixed-cart-wrap,.note-detail .text-cancle,.note-detail .text-save").on('click', function() {
    jQuery('.mini-cart-footer .note-detail').removeClass('open');
  });

  // Mini cart coupon
  jQuery(".cart-footer-actions .coupen-code").on("click", function() {    
    jQuery('.mini-cart-footer .discount-code').addClass('open');
  });
  jQuery(".fixed-cart-wrap,.discount-code .text-cancle,.discount-code .text-save").on('click', function() {
    jQuery('.mini-cart-footer .discount-code').removeClass('open');
  });

  /*-------------------- Filter toggle ------------------*/
  jQuery(".filter-toggle").on("click", function(e){
    e.preventDefault();
    jQuery(this).toggleClass("active");
    jQuery(".filter-toggle-wrap").slideToggle("is-visible");
  });
  /*-------------------- END ------------------*/

  // Cambiar imagen principal desde thumbs
  jQuery('.product-single__thumbs img').on('click', function () {
    var src = jQuery(this).attr('src');
    if (src) {
      jQuery(this)
        .closest('.product-wrapper')
        .find('img.grid-view-item__image')
        .first()
        .attr('src', src);
    }
    jQuery(this).parent('.grid-item').addClass('open').siblings('.grid-item').removeClass('open');
  });

  /*-------------------- video popup principal -------------------*/
  var p = jQuery(".popup_overlay");

  jQuery(".play-icone").on('click', function() {
    jQuery("body").addClass("popup-toggle");
    p.css("display", "block");
  });

  p.on('click', function(event) {
    var e = event || window.event;
    if (e.target === this) {
      jQuery(p).css("display", "none");
      jQuery('body').removeClass('popup-toggle'); 
    }
  });

  jQuery(".popup_close,.homeslider ul.slick-slider .slick-arrow").on('click', function() {
    p.css("display", "none");
    jQuery('body').removeClass('popup-toggle'); 
  });

  function toggleVideo(state) {
    var div = document.getElementById("popupVid");
    if (!div) return;
    var iframe = div.getElementsByTagName("iframe")[0];
    if (!iframe) return;
    var iframeWindow = iframe.contentWindow;
    var func = state === "hide" ? "pauseVideo" : "playVideo";
    iframeWindow.postMessage(
      '{"event":"command","func":"' + func + '","args":""}',
      "*"
    );
  }

  jQuery(".play-icone, .homeslider ul.slick-slider .slick-arrow").on('click', function() {
    p.css({ visibility: "visible", opacity: "1" });
  });

  p.on('click', function(event) {
    var e = event || window.event;
    if (e.target === this) {
      jQuery(p)
        .css({ visibility: "hidden", opacity: "0" });
      toggleVideo("hide");
    }
  });

  jQuery(".popup_close").on('click', function() {
    p.css({ visibility: "hidden", opacity: "0" });
    toggleVideo("hide");
  });

  /*------  video CMS about block ------*/
  var p1 = jQuery(".about-videoblock .popup_overlay");

  jQuery(".about-videoblock #popup_toggle").on('click', function() {
    jQuery("body").addClass("popup-toggle1");
    p1.css("display", "block");
  });

  p1.on('click', function(event) {
    var e = event || window.event;
    if (e.target === this) {
      jQuery(p1).css("display", "none");
      jQuery('body').removeClass('popup-toggle1'); 
    }
  });

  jQuery(".about-videoblock .popup_close").on('click', function() {
    p1.css("display", "none");
    jQuery('body').removeClass('popup-toggle1'); 
  });

  function toggleVideo1(state) {
    var div = document.getElementById("popupVid");
    if (!div) return;
    var iframe = div.getElementsByTagName("iframe")[0];
    if (!iframe) return;
    var iframeWindow = iframe.contentWindow;
    var func = state === "hide" ? "pauseVideo" : "playVideo";
    iframeWindow.postMessage(
      '{"event":"command","func":"' + func + '","args":""}',
      "*"
    );
  }

  jQuery(".about-videoblock #popup_toggle").on('click', function() {
    p1.css({ visibility: "visible", opacity: "1" });
  });

  p1.on('click', function(event) {
    var e = event || window.event;
    if (e.target === this) {
      jQuery(p1)
        .css({ visibility: "hidden", opacity: "0" });
      toggleVideo1("hide");
    }
  });

  jQuery(".about-videoblock .popup_close").on('click', function() {
    p1.css({ visibility: "hidden", opacity: "0" });
    toggleVideo1("hide");
  });

  /*------------------------- Checkout button icon --------------------*/
  jQuery(".shopify-payment-button .shopify-payment-button__button").prepend(
    jQuery("<i class='mdi mdi-cart-outline'></i>")
  );
  /*----------------------------------------------*/

  /*-------------------- Mobile Sticky --------------------*/
  function stickyScroll() {
    var $win = jQuery(window);
    var scrollTop = $win.scrollTop();
    var $sticky = jQuery('.main-sticky-data');
    if (!$sticky.length) return;

    var hidden = $sticky.attr('data-hidden');

    if (scrollTop > 100 && hidden === '1') {
      $sticky.attr('data-hidden', 0).addClass("fixed");
    } else if (scrollTop < 100 && hidden === '0') {
      $sticky.attr('data-hidden', 1).removeClass("fixed");
    } else if (scrollTop === jQuery(document).height() - $win.height()) {
      $sticky.attr('data-hidden', 1).removeClass("fixed");
    }
  }
  /*---------------------------END-------------------------------*/

  if (jQuery('.header_1 .wrapper-wrap').hasClass('logo_center'))  {
    jQuery('body').addClass('logo_center');
  }

  var w_width = jQuery(window).width();
  jQuery('.slider-content-main-wrap').css('width', w_width);

  if (jQuery('.site-header').hasClass('header_transaparent')) {
    jQuery('body.template-index').addClass('header_transaparent');
  }

  // Lightbox botón sólo para imagen activa
  var img_id = jQuery('.product-single__thumbs .slick-active.slick-current')
    .find('.product-single__thumb')
    .data('id');

  if (img_id && jQuery('.product-lightbox-btn').hasClass(img_id)) {
    jQuery('.product-lightbox-btn.' + img_id).show();
  }

  /*----------------------- Filtros offcanvas ----------------------*/
  jQuery(".filter-left").on("click", function(e){
    e.preventDefault();
    jQuery(this).toggleClass("active");
    jQuery(".off-canvas.position-left").addClass("is-open");
    jQuery(".js-off-canvas-overlay.is-overlay-fixed").addClass("is-visible is-closable");
  });

  jQuery(".filter-right").on("click", function(e){
    e.preventDefault();
    jQuery(this).toggleClass("active");
    jQuery(".off-canvas.position-right").addClass("is-open");
    jQuery(".js-off-canvas-overlay.is-overlay-fixed").addClass("is-visible is-closable");
  });

  jQuery(".off-canvas .sidebar_close").on("click", function(e){
    e.preventDefault();
    jQuery(".off-canvas.position-left").removeClass("is-open");
    jQuery(".off-canvas.position-right").removeClass("is-open");
    jQuery(".js-off-canvas-overlay.is-overlay-fixed").removeClass("is-visible is-closable");
  });

  jQuery(".is-overlay-fixed").on("click", function(e){
    e.preventDefault();
    jQuery(".filter-left").trigger('click');
    jQuery(".filter-right").trigger('click');
    jQuery(".off-canvas.position-left").removeClass("is-open");
    jQuery(".off-canvas.position-right").removeClass("is-open");
    jQuery(".js-off-canvas-overlay.is-overlay-fixed").removeClass("is-visible is-closable");
  });

  // 360 popup
  jQuery('.product-360-button a').magnificPopup({
    type: 'inline',
    mainClass: 'mfp-fade',
    removalDelay: 160,
    disableOn: false,
    preloader: false,
    fixedContentPos: false,
    callbacks: {
      open: function() {
        jQuery(window).trigger('resize');
      }
    }
  });

  // Countdowns
  countDownIni('.flip-countdown,.js-flip-countdown'); 

  /*--------------- popup video genérico ---------------------*/
  jQuery('.popup-video').magnificPopup({
    disableOn: 300,
    type: 'iframe',
    mainClass: 'mfp-fade',
    removalDelay: 160,
    preloader: false,
    fixedContentPos: false
  });

  // Lightbox producto (galería)
  if (jQuery('a.product-lightbox-btn').length > 0 || jQuery('a.product-video-popup').length > 0) {
    jQuery('.product-single__photos .gallery,.design_2 .product-img').magnificPopup({
      delegate: 'a',
      type: 'image',
      tLoading: '<div class="please-wait dark"><span></span><span></span><span></span></div>',
      removalDelay: 300,
      closeOnContentClick: true,
      gallery: {
        enabled: true,
        navigateByImgClick: false,
        preload: [0, 1]
      },
      image: {
        verticalFit: false,
        tError: '<a href="%url%">The image #%curr%</a> could not be loaded.'
      },
      callbacks: {
        beforeOpen: function() {
          var productVideo = jQuery('.product-video-popup').attr('href');
          if (productVideo) {
            this.st.mainClass = 'has-product-video';
            var galeryPopup = jQuery.magnificPopup.instance;
            galeryPopup.items.push({
              src: productVideo,
              type: 'iframe'
            });
            galeryPopup.updateItemHTML();
          }
        }
      }
    });
  }

  jQuery('.design_3 .product-img,.design_5 .pro_img').magnificPopup({
    delegate: 'a',
    type: 'image',
    tLoading: '<div class="please-wait dark"><span></span><span></span><span></span></div>',
    removalDelay: 300,
    closeOnContentClick: true,
    gallery: {
      enabled: true,
      navigateByImgClick: false,
      preload: [0, 1]
    },
    image: {
      verticalFit: false,
      tError: '<a href="%url%">The image #%curr%</a> could not be loaded.'
    },
    callbacks: {
      beforeOpen: function() {
        var productVideo = jQuery('.product-video-popup').attr('href');
        if (productVideo) {
          this.st.mainClass = 'has-product-video';
          var galeryPopup = jQuery.magnificPopup.instance;
          galeryPopup.items.push({
            src: productVideo,
            type: 'iframe'
          });
          galeryPopup.updateItemHTML();
        }
      }
    }
  });

  jQuery('body').on('click', '.product-lightbox-btn', function(e) {
    e.preventDefault();
    jQuery('.product-wrapper-owlslider').find('.owl-item.active a').trigger('click');
  });

  // Qty botones en productos (grid / bloques)
  jQuery('.product-layouts .qtyplus').on('click', function(e) {
    e.preventDefault();
    var $input = jQuery(this).parents('.qty-box-set').find('.quantity');
    var currentVal = parseInt($input.val(), 10);
    if (!isNaN(currentVal)) {
      $input.val(currentVal + 1);
    } else {
      $input.val(1);
    }
  });

  jQuery(".product-layouts .qtyminus").on('click', function(e) {
    e.preventDefault();
    var $input = jQuery(this).parents('.qty-box-set').find('.quantity');
    var currentVal = parseInt($input.val(), 10);
    if (!isNaN(currentVal) && currentVal > 1) {
      $input.val(currentVal - 1);
    } else {
      $input.val(1);
    }
  });

  /*---------------- END ------------------*/

  // Mobile nav simple
  jQuery("#navToggle").on('click', function() {
    jQuery(this).next('.Site-navigation').slideToggle(500);
  });

  jQuery(".menu_toggle_wrap #navToggle").on('click', function() {
    jQuery(this).parent().next('.Site-navigation').slideToggle(500);
  });

  // Footer modelo 1 toggle
  jQuery("body.footer_style_1 .footer_toggle").on("click", function(e){
    e.preventDefault();
    jQuery('#shopify-section-footer-model-1').addClass('toggle-footer'); 
    jQuery("body").addClass("footer1-open");
  });

  jQuery("body.footer_style_1 .footer_close_toggle").on("click", function(e){ 
    e.preventDefault();
    jQuery('#shopify-section-footer-model-1').removeClass('toggle-footer');
    jQuery("body").removeClass("footer1-open");
  });

  // Layout especial li_single1 (versión 1)
  jQuery('li.li_single1').each(function() {
    var $item = jQuery(this);
    var left = $item.find('.product-layouts ').filter(':eq(0), :eq(1)');
    var middle = $item.find('.product-layouts').eq(2);
    var right = $item.find('.product-layouts').filter(':eq(3), :eq(4)');

    jQuery(left).wrapAll("<div class='post-col-3 col-sm-3'></div>");
    jQuery(middle).wrapAll("<div class='post-col-1 col-sm-6'></div>");
    jQuery(right).wrapAll("<div class='post-col-2 col-sm-3'></div>");

    var row1 = $item.find('.post-col-1 .product-layouts').filter(':eq(0), :eq(1)');
    jQuery(row1).wrapAll("<div class='post-row-1'></div>");

    var row3 = $item.find('.post-col-3 .product-layouts').filter(':eq(0), :eq(1)');
    jQuery(row3).wrapAll("<div class='post-row-3'></div>");

    jQuery('.post-col-2 .product-wrapper .countdown').insertAfter('.post-col-2 .ttqtyprogress');
  });

  /*-------------- Search js ----------------*/
  jQuery(".site-header__search.search-full .serach_icon").on('click', function(e){
    e.preventDefault();
    jQuery(this).toggleClass('active'); 
    jQuery('body').toggleClass('search_full_active'); 
    jQuery(".search-full-screen").slideToggle("slow");
    jQuery('.full-search-wrapper').addClass('search-overlap');
    jQuery('.myaccount  .dropdown-toggle').removeClass("open");
    jQuery('.myaccount  .customer_account').slideUp("fast");  
    jQuery('.site-header .site-header_cart_link').removeClass("active");
    jQuery(".fixed-cart-wrap").removeClass('active');    
    jQuery(".search-bar > input").focus();
    jQuery('body').toggleClass('search_toggle'); 
    jQuery('body').removeClass('account-toggle cart_toggle');
  });

  jQuery(".site-header__search.search-full .close-search").on('click', function(){
    jQuery('.site-header__search.search-full .serach_icon').removeClass('active');
    jQuery('.full-search-wrapper').removeClass('search-overlap');  
    jQuery('body').removeClass('search_full_active search_toggle');
    jQuery(".search-full-screen").slideUp("slow");
  });

  jQuery(".site-header__search:not(.search-full) .serach_icon").on('click', function(){    
    jQuery(".search_wrapper").slideToggle("fast");
    jQuery(".search-bar > input").focus();
    jQuery(this).toggleClass('active');
    jQuery('body').toggleClass('search_toggle');
    jQuery('.site-header .site-header_cart_link').removeClass("active");
    jQuery('.myaccount  .dropdown-toggle').removeClass("open");  
    jQuery('.myaccount  .customer_account').slideUp("fast");       
    jQuery(".fixed-cart-wrap").removeClass('active');
    jQuery('body').removeClass('account-toggle cart_toggle');
  });

  /*-------------------- Myaccount -----------------*/
  jQuery(".myaccount span.dropdown-toggle").on('click', function(event){   
    event.preventDefault();
    jQuery(".customer_account").slideToggle("fast");
    jQuery(this).toggleClass('open');
    jQuery('body')
      .toggleClass('account-toggle')
      .removeClass('currency-open language-open search_toggle cart_toggle');

    jQuery('.site-header .site-header_cart_link').removeClass("active");       
    jQuery(".fixed-cart-wrap").removeClass('active');
    jQuery(".currencies.flag-dropdown-menu").slideUp("fast");
    jQuery(".header_language .disclosure-list").slideUp("fast"); 
  });

  jQuery(".header_language .disclosure__toggle").on("click", function (event) {     
    event.preventDefault();
    if (jQuery(window).width() > 992) {
      jQuery(".customer_account").stop(); 
      jQuery('body')
        .toggleClass('language-open')
        .removeClass('currency-open account-toggle cart_active myaccount_active');

      jQuery('.currency_wrapper').removeClass('active');
      jQuery(".disclosure-list").slideToggle("fast");
      jQuery(this).toggleClass('active'); 
      jQuery(".customer_account").slideUp("fast");
      jQuery(".currencies.flag-dropdown-menu").slideUp("fast");      
      jQuery(".fixed-cart-wrap").removeClass('active');
    }
  });

  jQuery(".header_currency .currency_wrapper.dropdown-toggle").on("click", function (event) {     
    event.preventDefault();
    if (jQuery(window).width() > 992) {
      jQuery('body')
        .toggleClass('currency-open')
        .removeClass('language-open account-toggle cart_active myaccount_active');

      jQuery('.disclosure__toggle').removeClass('active');
      jQuery(".currencies.flag-dropdown-menu").slideToggle("fast");
      jQuery(this).toggleClass('active'); 
      jQuery(".customer_account").slideUp("fast");
      jQuery(".header_language .disclosure-list").slideUp("fast");      
      jQuery(".fixed-cart-wrap").removeClass('active');
    }
  });
  /*-------------------- END -----------------*/

  // Slider móvil productos
  var galleryMobile = jQuery(".slider-mobile-gutter .product-grid");
  galleryMobile.owlCarousel({
    items : 6,
    dots: false,
    loop: false,
    nav: true,
    rewind:false,
    autoplay:false,
    responsive: {
      100: { items: 1 },
      315: { items: 2 },
      600: { items: 3 },
      992: { items: 4 },
      1300:{ items: 6 }
    }
  });

  // Barra de progreso de stock (slider special product)
  jQuery('.slider-specialproduct .product-wrapper').each(function(){
    var $wrapper = jQuery(this);
    var $desc = $wrapper.find('.product-description .progress');
    var $qty = $wrapper.find('.quantity');
    var $pbar = $wrapper.find('.progress-bar');

    var allowedWidth = parseInt($desc.css('width'), 10);
    if (!allowedWidth) return;

    var quantity = parseInt($qty.html(), 10) || 0;
    var currentWidth = parseInt($pbar.css('width'), 10) || 0;
    var addedWidth = currentWidth + quantity;

    if (addedWidth > allowedWidth) addedWidth = allowedWidth;

    var progress = (addedWidth / allowedWidth) * 100;
    $pbar.animate({ width: progress + '%' }, 100);
  });

  // Barra de progreso de stock (product page)
  jQuery('.product-single').each(function(){
    var $wrapper = jQuery(this);
    var $desc = $wrapper.find('.product-information .progress');
    var $qty = $wrapper.find('.quantity');
    var $pbar = $wrapper.find('.progress-bar');

    var allowedWidth = parseInt($desc.css('width'), 10);
    if (!allowedWidth) return;

    var quantity = parseInt($qty.html(), 10) || 0;
    var currentWidth = parseInt($pbar.css('width'), 10) || 0;
    var addedWidth = currentWidth + quantity;

    if (addedWidth > allowedWidth) addedWidth = allowedWidth;

    var progress = (addedWidth / allowedWidth) * 100;
    $pbar.animate({ width: progress + '%' }, 100);
  });

  /*------------------------- Owl galleries ------------------*/
  var brandsowl = jQuery("body:not(.rtl) .tt-brand_slider");
  var brandsowlrtl = jQuery("body.rtl .tt-brand_slider");

  brandsowl.owlCarousel({
    items : 7,
    dots: false,
    rewind:false,
    autoplay:true,
    autoplayHoverPause:true,
    nav: true,
    loop: false,
    responsive: {
      100:  { items: 2 },
      320:  { items: 2 },
      544:  { items: 3 },
      992:  { items: 4 },
      1200: { items: 5 },
      1300: { items: 6 },
      1530: { items: 7 }
    }
  });

  brandsowlrtl.owlCarousel({
    items : 7,
    dots: false,
    rewind:false,
    autoplay:true,
    autoplayHoverPause:true,
    nav: true,
    loop: false,
    responsive: {
      100:  { items: 2 },
      320:  { items: 2 },
      544:  { items: 3 },
      992:  { items: 4 },
      1200: { items: 5 },
      1300: { items: 6 },
      1530: { items: 7 }
    }
  });

  jQuery(".brands_next").on('click', function(){
    brandsowl.trigger('owl.next');
    brandsowlrtl.trigger('owl.next');
  });

  jQuery(".brands_prev").on('click', function(){
    brandsowl.trigger('owl.prev');
    brandsowlrtl.trigger('owl.prev');
  });

  // Slider nav producto
  var banner = jQuery(".product-thumb .slider-nav");
  banner.owlCarousel({
    items : 1,
    dots: false,
    loop: true,
    nav: true,
    rewind:true,
    autoplay:true,
    autoplayHoverPause: true,
    responsive: {
      100: { items: 1 },
      481: { items: 1 },
      992: { items: 1 },
      1200:{ items: 1 },
      1300:{ items: 1 }
    }
  });     

  // cmsblockbanner
  jQuery('.cmsblockbanner .ttbanner-wrap').owlCarousel({
    items :3,
    nav : false,
    dots : false,
    loop: false,
    autoplay:false,
    responsive: {
      992: { items: 3 },
      544: { items: 2 },
      320: { items: 1 },
      100: { items: 1 }
    }
  });

  // cmssubbanner
  jQuery('.ttcmsbanner .cms-banner').owlCarousel({
    items :2,
    nav : false,
    dots : false,
    loop: false,
    autoplay:false,
    responsive: {
      992: { items: 2 },
      544: { items: 2 },
      320: { items: 1 },
      100: { items: 1 }
    }
  });

  jQuery('.block_content .cmsofferblock').owlCarousel({
    items :7,
    nav : false,
    dots : false,
    loop: false,
    autoplay:false,
    responsive: {
      992: { items: 7 },
      544: { items: 2 },
      320: { items: 1 },
      100: { items: 1 }
    }
  });

  jQuery('body #footer-services .block_content').owlCarousel({
    items :4,
    nav : false,
    dots : true,
    loop: false,
    autoplay:false,
    rewindNav:true,
    responsive: {
      1200:{ items: 4 },
      700: { items: 3 },
      481: { items: 2 },
      100: { items: 1 }
    }
  });

  jQuery('body #ttcmsservices .block_content').owlCarousel({
    items :4,
    nav : false,
    dots : true,
    loop: false,
    autoplay:false,
    rewindNav:true,
    responsive: {
      1550:{ items: 4 },
      1300:{ items: 4 },
      992: { items: 3 },
      481: { items: 2 },
      100: { items: 1 }
    }
  });

  jQuery('body .about-services .block_content').owlCarousel({
    items :3,
    nav : false,
    dots : true,
    loop: false,
    autoplay:false,
    rewindNav:true,
    responsive: {
      1200:{ items: 3 },
      992: { items: 3 },
      481: { items: 2 },
      100: { items: 1 }
    }
  });

  jQuery('body .about-blog').owlCarousel({
    items :3,
    nav : false,
    dots : true,
    loop: false,
    autoplay:false,
    rewindNav:true,
    responsive: {
      1200:{ items: 3 },
      992: { items: 3 },
      481: { items: 2 },
      100: { items: 1 }
    }
  });

  jQuery('body:not(.rtl) #tt-megamenu .list_product_menu_content').owlCarousel({
    items : 1,
    nav : false,
    autoPlay:true,
    autoplaySpeed:1000,
    stopOnHover: false,
    loop: false,
    dots : true,
    responsive: {
      768: { items: 1 },
      360: { items: 1 },
      100: { items: 1 }
    }
  });

  jQuery('body.rtl #tt-megamenu .list_product_menu_content').owlCarousel({
    items : 1,
    nav : true,
    autoPlay:true,
    autoplaySpeed:1000,
    rtl: true,
    stopOnHover: false,
    loop: false,
    dots : true,
    responsive: {
      768: { items: 1 },
      360: { items: 1 },
      100: { items: 1 }
    }
  });

  jQuery('body:not(.rtl) .flash-sale .list_product_menu_content').owlCarousel({
    items : 7,
    nav : true,
    autoPlay:true,
    autoplaySpeed:1000,
    stopOnHover: false,
    loop: false,
    dots : false,
    responsive: {
      1600:{ items: 7 },
      1300:{ items: 6 },
      1200:{ items: 5 },
      992: { items: 4 },
      100: { items: 1 }
    }
  });

  jQuery('body.rtl .flash-sale .list_product_menu_content').owlCarousel({
    items : 7,
    nav : true,
    autoPlay:true,
    autoplaySpeed:1000,
    rtl: true,
    stopOnHover: false,
    loop: false,
    dots : false,
    responsive: {
      1600:{ items: 7 },
      1300:{ items: 6 },
      1200:{ items: 5 },
      992: { items: 4 },
      100: { items: 1 }
    }
  });

  // Full gallery slider
  jQuery(".full_gallery_slider.owl-carousel").on("changed.owl.carousel", function(e){
    var element = e.target;
    var items = e.item.count;
    var item = e.relatedTarget.relative(e.item.index) + 1; 
    jQuery(element).parent().find('.num').html(item + "/" + items);
  });

  jQuery('body:not(.rtl) .full_gallery_slider.owl-carousel').owlCarousel({
    loop:true,
    startPosition:0,
    center: true,
    dots:true,
    items:1,
    lazyLoad: true,
    nav:false,
    responsive:{
      100:{ items:1 },
      767:{ items:1 },
      991:{ items:3 },
      1199:{ items:3 },
      1299:{ items:3 }
    }
  });

  jQuery('body.rtl .full_gallery_slider.owl-carousel').owlCarousel({
    stagePadding: 200,
    loop:true,
    startPosition:0,
    center: true,
    dots:true,
    items:1,
    rtl:true,
    lazyLoad: true,
    nav:false,
    responsive:{
      0:   { items:1, stagePadding: 60 },
      600: { items:1, stagePadding: 150 },
      768: { items:1, stagePadding: 180 },
      868: { items:1, stagePadding: 250 },
      1800:{ items:1, stagePadding: 300 }
    }
  });

  jQuery('body:not(.rtl) .tt-testimonial-wrap .testimonials_wrap').owlCarousel({
    items: 1,
    nav: true,
    navText: [
      "<i class='mdi mdi-chevron-left'></i>",
      "<i class='mdi mdi-chevron-right'></i>"
    ],
    dots: true,
    loop: false,
    autoplay: false,
    autoplayHoverPause: true,
    responsive: {
      1279:{ items: 1 },
      1250:{ items: 1 },
      600: { items: 1 }
    }
  });

  jQuery('body.rtl .tt-testimonial-wrap .testimonials_wrap').owlCarousel({
    items: 1,
    nav: true,
    navText: [
      "<i class='mdi mdi-chevron-left'></i>",
      "<i class='mdi mdi-chevron-right'></i>"
    ],
    rtl: true,
    dots: true,
    autoplay: false,
    loop: false,
    autoplayHoverPause: true,
    responsive: {
      1279:{ items: 1 },
      1250:{ items: 1 },
      600: { items: 1 }
    }
  });

  // Otra barra de progreso stock (product-single variante)
  jQuery('.product-single').each(function(){
    var $wrapper = jQuery(this);
    var $desc = $wrapper.find('.product-wrapper .progress');
    var $qty = $wrapper.find('.quantity');
    var $pbar = $wrapper.find('.progress-bar');

    var allowedWidth = parseInt($desc.css('width'), 10);
    if (!allowedWidth) return;

    var quantity = parseInt($qty.html(), 10) || 0;
    var currentWidth = parseInt($pbar.css('width'), 10) || 0;
    var addedWidth = currentWidth + quantity;

    if (addedWidth > allowedWidth) addedWidth = allowedWidth;

    var progress = (addedWidth / allowedWidth) * 100;
    $pbar.animate({ width: progress + '%' }, 100);
  });  

  // Slider best product
  jQuery('body .slider-bestproduct').owlCarousel({
    items : 1,
    nav : true,
    autoplay:false,
    autoplaySpeed:1500,	
    dots : false,
    responsive: {
      100: { items: 1 },
      620: { items: 1 },
      1200:{ items: 1 },   
      1430:{ items: 1 }
    }
  });

  jQuery('.slider-bestproduct-inner').each(function () { 
    var $inner = jQuery(this);
    if ($inner.find('.owl-nav').hasClass('disabled')) {
      $inner.find('.customNavigation').hide();
    } else {
      $inner.find('.customNavigation').show();
    }
  });

  jQuery(".slider-bestproduct-inner .customNavigation .next").on('click', function(){
    var wrap = jQuery(this).closest('.slider-bestproduct-inner');
    wrap.find('.slider-bestproduct').trigger('next.owl');
  });

  jQuery(".slider-bestproduct-inner .customNavigation .prev").on('click', function(){
    var wrap = jQuery(this).closest('.slider-bestproduct-inner');
    wrap.find('.slider-bestproduct').trigger('prev.owl');
  });

  // Slider featured product
  var p_col = jQuery('.slider-featuredproduct').data('col') || 4;

  jQuery('body .slider-featuredproduct').owlCarousel({
    items : p_col,
    nav : true,
    autoplay:false,
    autoplaySpeed:1500,	
    dots : false,
    responsive: {
      100: { items: 1 },
      319: { items: 2 },
      751: { items: 3 },   
      1300:{ items: 4 },
      1400:{ items: 4 },
      1770:{ items: p_col }
    }
  });

  jQuery('.slider-featuredproduct-inner').each(function () { 
    var $inner = jQuery(this);
    if ($inner.find('.owl-nav').hasClass('disabled')) {
      $inner.find('.customNavigation').hide();
    } else {
      $inner.find('.customNavigation').show();
    }
  });

  jQuery(".slider-featuredproduct-inner .customNavigation .next").on('click', function(){
    var wrap = jQuery(this).closest('.slider-featuredproduct-inner');
    wrap.find('.slider-featuredproduct').trigger('next.owl');
  });

  jQuery(".slider-featuredproduct-inner .customNavigation .prev").on('click', function(){
    var wrap = jQuery(this).closest('.slider-featuredproduct-inner');
    wrap.find('.slider-featuredproduct').trigger('prev.owl');
  });

  // Category feature carousel
  jQuery('body:not(.rtl) .category_feature1').owlCarousel({             
    items: 5,
    nav : false,
    dots : false,
    autoplay:true,
    loop:true,
    rtl:false,
    autoplayHoverPause: false,
    lazyLoad: true,
    smartSpeed: 1000,
    autoplayTimeout: 3000,
    responsive: {
      100: { items: 1 },
      320: { items: 2 },
      481: { items: 3 },
      768: { items: 4 },
      1300:{ items: 5 }
    }
  });

  jQuery('body.rtl .category_feature1').owlCarousel({
    items: 5,
    nav : false,
    dots : false,
    autoplay:true,
    loop:true,
    rtl:false,
    autoplayHoverPause: false,
    lazyLoad: true,
    smartSpeed: 1000,
    autoplayTimeout: 3000,
    responsive: {
      100: { items: 1 },
      320: { items: 2 },
      481: { items: 3 },
      768: { items: 4 },
      1300:{ items: 5 }
    }
  });

  // Top rated products widget
  jQuery('body:not(.rtl) .widget_top_rated_products .top-products').owlCarousel({
    items : 1,
    nav : true,
    dots : true,
    loop: false,
    autoplay:true,
    rtl:false,
    responsive: {
      1279:{ items: 1 },
      600: { items: 1 }
    }
  });

  jQuery('body.rtl .widget_top_rated_products .top-products').owlCarousel({
    items : 1,
    nav : true,
    dots : true,
    loop: false,
    autoplay:true,				
    rtl:true,
    responsive: {
      1279:{ items: 1 },
      600: { items: 1 }
    }
  });

  // Review toggle
  jQuery(".spr-summary-actions-newreview").on('click', function(e) {
    e.preventDefault();
    jQuery(".spr-content").slideToggle("slow");
  });

  // Botones loading (quick view, add to cart, compare)
  jQuery(".pro_btn.quick-view-wrap > a,.pro_btn.add_tocart form > a,.pro_btn.add-to-compare .add-in-compare-js")
    .on('click', function(){
      var $btns = jQuery(".pro_btn.quick-view-wrap > a,.pro_btn.add_tocart form > a,.pro_btn.add-to-compare .add-in-compare-js");
      jQuery(this).addClass("loading");
      setTimeout(function() {
        $btns.removeClass("loading");
      }, 2000);
    });

  // Header banner close
  jQuery('.headerbanner-close').on("click", function(){
    jQuery('.ttcmstopbanner').slideToggle("slow", function() {});
    jQuery('body').addClass('headerbanner-close');
  });

  if (jQuery('body:not(.template-index) .site-header .toggle_menu').hasClass('current-close')) {
    jQuery('.tt-mega_menu').slideUp(2000);
  }

  // Mega menú toggle
  jQuery('.toggle_menu').on('click', function() {
    var $this = jQuery(this);
    var isSticky = jQuery('.sticky_header').hasClass('fixed');
    var isMobile = jQuery(window).width() < 992;

    if ($this.hasClass('default-open') && isMobile) {
      if ($this.hasClass('current-close')) {
        $this.addClass("current-open").removeClass("current-close");
        jQuery('body').addClass("menu-current-open");
        jQuery('.tt-mega_menu').slideToggle(2000);
      } else {
        $this.removeClass("default-open").addClass("current-open").removeClass("current-close");
        jQuery('body').addClass("menu-current-open");
        jQuery('.tt-mega_menu').slideToggle(2000);
      }    
    } else if ($this.hasClass('default-open')) {
      if ($this.hasClass('current-close')) {
        $this.addClass("current-open").removeClass("current-close");
        jQuery('body').addClass("menu-current-open");
        jQuery('.tt-mega_menu').slideToggle(2000);
      } else if ($this.hasClass('current-open')) {
        $this.addClass("current-close").removeClass("current-open");
        jQuery('body').removeClass("menu-current-open");
        jQuery('.tt-mega_menu').slideToggle(2000);
      }
    } else {
      if ($this.hasClass('current-open')) {
        $this.addClass("current-close").removeClass("current-open");
        jQuery('body').removeClass("menu-current-open");
        jQuery('.tt-mega_menu').slideToggle(2000);
      } else {
        $this.addClass("current-open").removeClass("current-close");
        jQuery('body').addClass("menu-current-open");
        jQuery('.tt-mega_menu').slideToggle(2000);
      }
    }

    if ($this.hasClass('default-open') && !isSticky) {
      $this.addClass("current-close").removeClass("default-open");
      jQuery('.tt-mega_menu').slideToggle(2000);
    }	

    if ($this.hasClass('default-open') && isSticky) {
      $this.addClass("current-open").removeClass("default-open");
      jQuery('body').addClass("menu-current-open");
      jQuery('.tt-mega_menu').slideDown(2000);
    }
  });

  // Gallery del CMS
  var gallery = jQuery("#cmsgallery .image-content");
  gallery.owlCarousel({
    items : 5,
    dots: false,
    loop: false,
    nav: true,
    rewind:false,
    autoplay:false,
    responsive: {
      100: { items: 1 },
      315: { items: 2 },
      600: { items: 3 },
      992: { items: 4 },
      1300:{ items: 5 }
    }
  });

  // Hoverdir en links de thumbs
  jQuery('.product-thumb .grid-view-item__links').each(function(){  	    
    jQuery(this).hoverdir();   
  });

  // Menú responsive inicial
  responsiveMenu();

  // Ir a pestaña de reviews desde botón
  jQuery(".product-write-review").on('click', function(e) {
    e.preventDefault();
    jQuery("a[href='#tab-2']").trigger('click');
    jQuery('html, body').animate({
      scrollTop: jQuery(".product_tab_wrapper").offset().top - 150
    }, 1000);
  });

  // Sticky cart inicial
  productcartsticky();

  // Footer toggle inicial
  footerToggle();

  // Sidebar sticky inicial
  sidebarsticky();

  // Igualar alturas inicial
  height();
});

/*------------------------ END DOCUMENT READY ------------------------*/

// Menú "More" en navegación principal
function moremenu() { 
  var max_elem = (jQuery(document).width() <= 1199) ? 4 : 5;
  var items = jQuery(".tt_menus_ul1 > li");
  var surplus = items.slice(max_elem);

  if (!surplus.length) return;

  surplus.wrapAll('<li class="more_menu tt_menu_item"><ul class="tt_menus_ul1"></ul></li>');
  jQuery('.more_menu').prepend('<a href="#" class="level-top topmega-menu-link">More</a>');

  jQuery('.more_menu').on('mouseover', function(){
    jQuery(this).children('ul').addClass('shown-link');
    jQuery('body').addClass('menu-open');
  });

  jQuery('.more_menu').on('mouseout', function(){
    jQuery(this).children('ul').removeClass('shown-link');
    jQuery('body').removeClass('menu-open');      
  });

  jQuery(".tt_menus_ul1").css('display', 'inline-block');
}

jQuery(document).ready(function(){
  moremenu();
});

/*---------------- Scroll: botón GotoTop + sticky + animaciones + header ----------------*/
var prevScrollpos = window.pageYOffset;

jQuery(window).on('scroll', function(e) {
  // Mobile sticky
  stickyScroll();

  // Mostrar / ocultar botón GotoTop
  if (jQuery(document).height() > jQuery(window).height()) {
    var scroll = jQuery(window).scrollTop();
    if (scroll > 100) {
      jQuery("#GotoTop").fadeIn();
    } else {
      jQuery("#GotoTop").fadeOut();
    }
  }

  // Sticky cart
  productcartsticky();

  // Alturas de thumbs / vídeos
  height();

  // Animaciones on scroll
  hb_animated_contents();

  // Header sticky que sube/baja
  var currentScrollPos = window.pageYOffset;
  var headerSticky = document.getElementById("header-sticky");

  if (headerSticky) {
    if (
      prevScrollpos > currentScrollPos ||
      jQuery('body').hasClass('account-toggle') ||
      jQuery('body').hasClass('menu_hover') ||
      jQuery('body').hasClass('cart_toggle') ||
      jQuery('body').hasClass('search_toggle') ||
      jQuery('body').hasClass('menu-current-open')
    ) {
      headerSticky.style.top = "0";
    } else {
      headerSticky.style.top = "-100px";
    }
  }

  prevScrollpos = currentScrollPos;
});

/*---------------- Extra layout li_single1 (versión 2) ----------------*/
jQuery('li.li_single1').each(function(){
  var $item = jQuery(this);

  var left   = $item.find('.product-layouts ').filter(':eq(0), :eq(1), :eq(2), :eq(3)');
  var middle = $item.find('.product-layouts').eq(4);
  var right  = $item.find('.product-layouts ').filter(':eq(5), :eq(6), :eq(7), :eq(8)');

  jQuery(left).wrapAll("<div class='post-col-1 col-sm-4'></div>");
  jQuery(middle).wrapAll("<div class='post-col-2 col-sm-4'></div>");
  jQuery(right).wrapAll("<div class='post-col-3 col-sm-4'></div>");

  var row1 = $item.find('.post-col-1 .product-layouts').filter(':eq(0), :eq(1)');
  jQuery(row1).wrapAll("<div class='post-row-1'></div>");

  var row2 = $item.find('.post-col-1 .product-layouts').filter(':eq(2), :eq(3)');
  jQuery(row2).wrapAll("<div class='post-row-2'></div>");

  var row3 = $item.find('.post-col-3 .product-layouts').filter(':eq(0), :eq(1)');
  jQuery(row3).wrapAll("<div class='post-row-3'></div>");

  var row4 = $item.find('.post-col-3 .product-layouts').filter(':eq(2), :eq(3)');
  jQuery(row4).wrapAll("<div class='post-row-4'></div>");

  jQuery('.post-col-2 .product-wrapper .countdown').insertAfter('.post-col-2 .ttqtyprogress');
});

/*---------------- Responsive menu (desktop / mobile) ----------------*/
function responsiveMenu(){
  if (jQuery(window).width() < 992) {
    jQuery('.sub-nav__dropdown').css('display', 'none');    

    jQuery('.tthorizontal_menu').appendTo('#tt-megamenu .tt_menus_ul');        
    jQuery('.header_1 .bottom_header_1 .ttresponsive_menu').insertBefore('.header_1 .main-header .header_logo_wrap');
    jQuery('.header_1 .main-header .right-link-icon').insertAfter('.header_1 .main-header .header_logo_wrap');
    jQuery('.header_1 .bottom_header_1 .wish-com').insertAfter('.header_1 .main-header .right-link-icon');
    jQuery('.header_1 .wishlist-icon-div').appendTo('.header_1 .myaccount .customer_account');
    jQuery('.header_1 .compare-icon-div').insertAfter('.header_1 .wishlist-icon-div');
    jQuery('.header_1 .top_header_1 .track-order').insertAfter('.header_1 .main-header #tt-megamenu .tt_menus_ul');
    jQuery('.header_1 .top_header_1 .topright-header').insertAfter('.header_1 .main-header #tt-megamenu .track-order');
    jQuery('.header_1 .top_header_1 .flash-sale').insertBefore('.header_1 .main-header #tt-megamenu .topright-header');
    jQuery('.header_language').insertAfter('.header_1 .compare-icon-div');
    jQuery('.header_currency').insertAfter('.header_1 .header_language');
  } else {         
    jQuery('.header_1 #tt-megamenu .tt_menus_ul .tthorizontal_menu').prependTo('.header_1 .bottom_header_1 .container'); 
    jQuery('.header_1 .main-header .ttresponsive_menu').appendTo('.header_1 .bottom_header_1 .container');          
    jQuery('.header_1 .main-header .right-link-icon').insertAfter('.header_1_wrapper .main-header .site-header__search');
    jQuery('.header_1 .track-order').prependTo('.header_1_wrapper .top_header_1 .top-header');
    jQuery('.header_1 .topright-header').insertAfter('.header_1_wrapper .top_header_1 .top-header');
    jQuery('.header_1 .flash-sale').appendTo('.header_1_wrapper .top_header_1 .top-header');
    jQuery('.header_1 .wishlist-icon-div').prependTo('.header_1 .main-header .wish-com');
    jQuery('.header_1 .compare-icon-div').insertAfter('.header_1 .wishlist-icon-div');    
    jQuery('.header_1 .customer_account .header_language').insertAfter('.header_1_wrapper .top_header_1 .top-header .track-order');
    jQuery('.header_1 .customer_account .header_currency').insertAfter('.header_1_wrapper .top_header_1 .top-header .header_language');
    jQuery('.header_1 .main-header .wish-com').appendTo('.header_1 .bottom_header_1 .container');
  }
}

/*---------------- Igualar alturas de thumbs y vídeos ----------------*/
function height(){
  var maxHeight = jQuery(".design_2 .product-block .image,.design_5 .product-block .image,.design_1 .product-single__thumbs a.product-single__thumbnail img,.design_3 .product-single__thumbs a.product-single__thumbnail img").height();

  jQuery(".design_2 .product-block .extra-video,.design_5 .product-block .extra-video,.design_1 .product-single__thumbs a.product-single__thumbnail.extra-video img,.design_3 .product-single__thumbs a.product-single__thumbnail.extra-video img").height(maxHeight);
  jQuery(".design_2 .product-block .video,.design_5 .product-block .video,.design_1 .product-single__thumbs a.product-single__thumbnail.video img,.design_3 .product-single__thumbs a.product-single__thumbnail.video img").height(maxHeight);
  jQuery(".design_2 .product-block .model,.design_5 .product-block .model,.design_1 .product-single__thumbs a.product-single__thumbnail.model img,.design_3 .product-single__thumbs a.product-single__thumbnail.model img").height(maxHeight);
}

/*---------------- Sticky add-to-cart (product page) ----------------*/
function productcartsticky() {
  if (jQuery(window).width() > 319) {
    if (jQuery(window).scrollTop() > 550) {
      jQuery('.add-to-cart-sticky').addClass("fixed");
    } else {
      jQuery('.add-to-cart-sticky').removeClass("fixed");
    }
  } else {
    jQuery('.add-to-cart-sticky').removeClass("fixed");
  }
}

/*---------------- Footer accordion + sidebar en mobile ----------------*/
function footerToggle() {
  if (jQuery(window).width() < 992) {   
    jQuery('.left-sidebar.sidebar').insertAfter('.collection_wrapper');
    jQuery('.sidebar .collection_sidebar .sidebar-block').insertAfter('.filter-wrapper');

    jQuery(".right-sidebar.sidebar .widget > h4,.left-sidebar.sidebar .widget > h4,.blog-section .sidebar .widget > h4").addClass("toggle");
    jQuery(".right-sidebar.sidebar .widget,.left-sidebar.sidebar .widget,.blog-section .sidebar .widget").children(':nth-child(2)').hide();
    jQuery(".right-sidebar.sidebar .widget.active,.left-sidebar.sidebar .widget.active,.blog-section .sidebar .widget.active").children(':nth-child(2)').show();

    jQuery(".right-sidebar.sidebar .widget > h4.toggle,.left-sidebar.sidebar .widget > h4.toggle,.blog-section .sidebar .widget > h4.toggle")
      .off("click")
      .on('click', function() {
        jQuery(this).parent().toggleClass('active').children(':nth-child(2)').slideToggle("fast");
      });

    jQuery(".collection_right .sidebar-block .widget > h4,.collection_left .sidebar-block .widget > h4,.filter-toggle-wrap .sidebar-block .widget > h4").addClass("toggle");
    jQuery(".collection_right .sidebar-block .widget,.collection_left .sidebar-block .widget,.filter-toggle-wrap .sidebar-block .widget").children(':nth-child(2)').hide();
    jQuery(".collection_right .sidebar-block .widget.active,.collection_left .sidebar-block .widget.active,.filter-toggle-wrap .sidebar-block .widget.active").children(':nth-child(2)').show();

    jQuery(".collection_right .sidebar-block .widget > h4.toggle,.collection_left .sidebar-block .widget > h4.toggle,.filter-toggle-wrap .sidebar-block .widget > h4.toggle")
      .off("click")
      .on('click', function() {
        jQuery(this).parent().toggleClass('active').children(':nth-child(2)').slideToggle("fast");
      });
  } else {
    jQuery('.sidebar-block').prependTo('.collection_sidebar');
    jQuery('.left-sidebar.sidebar').insertBefore('.collection_wrapper');
    jQuery(".sidebar .widget > h4,.sidebar-block .widget > h4")
      .off("click")
      .removeClass("toggle");
    jQuery(".sidebar .widget,.sidebar-block .widget").children(':nth-child(2)').show();
  }
}

/*---------------- Sticky sidebar ----------------*/
function sidebarsticky() { 
  var width = jQuery(document).width();
  var marginTop = (width >= 1200) ? 130 : 30;

  jQuery('.left-sidebar.sidebar,.right-sidebar.sidebar,.collection_right,.collection_left').theiaStickySidebar({
    additionalMarginBottom: 30,
    additionalMarginTop: marginTop
  });
}

/*---------------- Utilidades varias ----------------*/
function splitStr(string, seperator){
  return string.split(seperator);
}

function countDownIni(countdown) {
  jQuery(countdown).each(function () {
    var $countdown = jQuery(this);
    var promoperiod;

    if ($countdown.attr('data-promoperiod')) {
      promoperiod = new Date().getTime() + parseInt($countdown.attr('data-promoperiod'), 10);
    } else if ($countdown.attr('data-countdown')) {
      promoperiod = $countdown.attr('data-countdown');
    }

    if (Date.parse(promoperiod) - Date.parse(new Date()) > 0) {
      $countdown.addClass('countdown-block');
      $countdown.countdown(promoperiod, function (event) {
        $countdown.html(
          event.strftime(
            '<span><span class="left-txt">Left</span><span>%D</span><span class="time-txt">Days</span></span>' +
            '<span><span>%H</span><span class="time-txt">Hrs</span></span>' +
            '<span><span>%M</span><span class="time-txt">Min</span></span>' +
            '<span><span class="second">%S</span><span class="time-txt">Sec</span></span>'
          )
        );
      });
    }
  });
}

/*---------------- Animaciones custom (hb-animate-element) ----------------*/
function hb_animated_contents() {
  jQuery(".hb-animate-element:in-viewport").each(function (i) {
    var $this = jQuery(this);
    if (!$this.hasClass('hb-in-viewport')) {
      setTimeout(function () {
        $this.addClass('hb-in-viewport');
      }, 180 * i);
    }
  });
}

/*---------------- Eventos de resize unificados ----------------*/
jQuery(window).on('resize', function() {
  responsiveMenu();
  footerToggle();
  sidebarsticky();
  productcartsticky();
  height();

  var w_width = jQuery(window).width();
  jQuery('.slider-content-main-wrap').css('width', w_width);

  var h = jQuery('.design_3 .product-wrapper-owlslider').height();
  jQuery('.design_3 .product-information-inner.tt-scroll').css('min-height', h + "px");
});

/*---------------- Window load (imágenes cargadas + sticky qty) ----------------*/
jQuery(window).on('load', function() {
  // Altura mínima de contenido en diseño 3
  var h = jQuery('.design_3 .product-wrapper-owlslider').height();
  jQuery('.design_3 .product-information-inner.tt-scroll').css('min-height', h + "px");

  // Animaciones iniciales
  hb_animated_contents();

  // Sincronizar qty entre sticky y bloque principal
  jQuery(".add-to-cart-sticky .qty-box-set .qnt_wrap .button").on('click', function() {
    var valquantity = jQuery(".add-to-cart-sticky .qty-box-set input.quantity").val();
    jQuery(".quantity__input").val(valquantity);
    jQuery('.add-to-cart-sticky .qty-box-set .quantity').val(valquantity);
  });

  jQuery(".product-information-inner .qty-box-set").on('click', function() {
    var quantityval = jQuery(".quantity__input").val();
    jQuery(".quantity__input").val(quantityval);
    jQuery('.add-to-cart-sticky .qty-box-set .quantity').val(quantityval);
  });

  // Qty en sticky bar
  jQuery('.sticky-data .product-qty .qtyplus').on('click', function() {
    var $input = jQuery(this).parents('.qty-box-set').find('.quantity');
    var currentVal = parseInt($input.val(), 10);
    if (!isNaN(currentVal)) {
      $input.val(currentVal + 1);
    } else {
      $input.val(1);
    }
  });

  jQuery(".sticky-data .product-qty .qtyminus").on('click', function() {
    var $input = jQuery(this).parents('.qty-box-set').find('.quantity');
    var currentVal = parseInt($input.val(), 10);
    if (!isNaN(currentVal) && currentVal > 1) {
      $input.val(currentVal - 1);
    } else {
      $input.val(1);
    }
  });
});

/*---------------- Accordions de menú y footer ----------------*/
jQuery(function() {
  // Top categories accordion
  var Accordion = function(el, multiple) {
    this.el = el || {};
    this.multiple = multiple || false;
    jQuery('.cat-cnt').addClass('active');

    var links = this.el.find('.cat-cnt .mobile-nav__sublist-trigger');
    links.on('click', { el: this.el, multiple: this.multiple }, this.dropdown);
  };

  Accordion.prototype.dropdown = function(e) {
    e.preventDefault();
    var $el = e.data.el;
    var $this = jQuery(this);
    var $next = $this.next();

    $next.slideToggle();
    $this.parent().toggleClass('open');

    if (!e.data.multiple) {
      $el.find('.tt_sub_menu_linklist').not($next).slideUp().parent().removeClass('open');
    }
  };

  new Accordion(jQuery('.topcat_content'), false);
});

jQuery(function() {
  // Menú principal (accessibleNav)
  var Accordion = function(el, multiple) {
    this.el = el || {};
    this.multiple = multiple || false;

    var links = this.el.find('.menu-item-depth-0 .mobile-nav__sublist-trigger');
    links.on('click', { el: this.el, multiple: this.multiple }, this.dropdown);
  };

  Accordion.prototype.dropdown = function(e) {
    var $el = e.data.el;
    var $this = jQuery(this);
    var $next = $this.next();

    $next.slideToggle();
    $this.parent().toggleClass('open');

    if (!e.data.multiple) {
      $el.find('.menu-item-depth-0 .sub-nav__dropdown').not($next).slideUp().parent().removeClass('open');
    }
  };

  new Accordion(jQuery('#accessibleNav'), false);
});

jQuery(function() {
  // Mega menú horizontal en mobile
  if (!jQuery('body').hasClass('fullnav-open'))  {
    var Accordion = function(el, multiple) {
      this.el = el || {};
      this.multiple = multiple || false;

      var links = this.el.find('li.tt_mm_hassub .mobile-nav__sublist-trigger');
      links.on('click', { el: this.el, multiple: this.multiple }, this.dropdown);
    };

    Accordion.prototype.dropdown = function(e) {
      var $el = e.data.el;
      var $this = jQuery(this);
      var $next = $this.next();

      $next.slideToggle();
      $this.parent().toggleClass('open');

      if (!e.data.multiple) {
        $el.find('li.tt_mm_hassub .tt_sub_menu_wrap').not($next).slideUp().parent().removeClass('open');
      }
    };

    new Accordion(jQuery('.tt_menus_ul'), false);
  }
});

jQuery(function() {
  // Footer columns
  var Accordions = function(el, multiple) {
    this.el = el || {};
    this.multiple = multiple || false;

    var link = this.el.find('.toggle');
    link.on('click', { el: this.el, multiple: this.multiple }, this.dropdown);
  };

  Accordions.prototype.dropdown = function(e) {
    var $el = e.data.el;
    var $this = jQuery(this);
    var $next = $this.next();

    $next.slideToggle();
    $this.parent().toggleClass('active');

    if (!e.data.multiple) {
      $el.find('.inline-list').not($next).slideUp().parent().removeClass('active');
    }
  };

  new Accordions(jQuery('.footer-column'), false);
});

/*---------------- Qty en productos (layout general fuera de ready) ----------------*/
jQuery('.product-layouts .qtyplus').on('click', function() {
  var $input = jQuery(this).parents('.qty-box-set').find('.quantity');
  var currentVal = parseInt($input.val(), 10);
  if (!isNaN(currentVal)) {
    $input.val(currentVal + 1);
  } else {
    $input.val(1);
  }
});

jQuery(".product-layouts .qtyminus").on('click', function() {
  var $input = jQuery(this).parents('.qty-box-set').find('.quantity');
  var currentVal = parseInt($input.val(), 10);
  if (!isNaN(currentVal) && currentVal > 1) {
    $input.val(currentVal - 1);
  } else {
    $input.val(1);
  }
});

/*---------------- Sincronizar botón AddToCart (ID duplicado) ----------------*/
jQuery("#AddToCart1").on('click', function() {
  jQuery("#AddToCart").trigger("click");
});
